export const FETCH_GLOBAL_PROJECT_NAME_REQUEST = 'FETCH_GLOBAL_PROJECT_NAME_REQUEST'
export const FETCH_GLOBAL_PROJECT_NAME_SUCCESS = 'FETCH_GLOBAL_PROJECT_NAME_SUCCESS'
export const FETCH_GLOBAL_PROJECT_NAME_FALUIRE = 'FETCH_GLOBAL_PROJECT_NAME_FALUIRE'
